var eventList = {
  loading:false,
  dayNum:1,
  maxDays:7,
  loadedDates:[],
  timezoneOffset:-10,
  timezone:"Pacific/Honolulu", // hawaii timezone
  cacheRoot:"https://media.hubhawaii.com/events/cache/"+ELAJAX.calendarID+"/",
  filterRegionName:false,
  listRegionName:false,
  filterCategoryNames:[],
  load:async function(holderID,startTimestamp){
    this.holderID = holderID;
    this.holder = document.getElementById(holderID);
    this.startTimestamp = startTimestamp;
    //this.headerOffset = window.innerWidth < 768 ? 64 : 44;
    this.headerOffset = false;

    

    this.events();
    await this.loadNextDay();
    await this.loadNextDay();
  },
  loadNewDate:async function(dateString){
    
    this.disableScrollEvent = true;
    
    let [month,date,year] = dateString.split("-");

    let newDateObj = new Date(Date.UTC(year,parseInt(month)-1,date));
    let newTimestamp = newDateObj.getTime();
    var eventListBounds = this.holder.getBoundingClientRect();
    window.scrollTo({top:eventListBounds.top + window.scrollY-this.headerOffset+1,behavior:"auto"});

    /*
    var dateHeaders = this.holder.querySelectorAll(".dateHeader");
    dateHeaders.forEach(d=>d.remove());
    var events = this.holder.querySelectorAll(".event");
    events.forEach(d=>d.remove());
    events = null;

    var eventslm = this.holder.querySelectorAll(".eventsLoadMore");
    eventslm.forEach(d=>d.remove());
    eventslm = null;

    var dateSpacers = this.holder.querySelectorAll(".dateSpacer");
    dateSpacers.forEach(d=>d.remove());
    dateSpacers = null;
*/
console.log("LOAD NEW DATE TRIGGERED");
    while(this.holder.querySelector(".event")){
        this.holder.removeChild(this.holder.querySelector(".event"));
    }
    if(this.holder.querySelector(".noListings")){
      while(this.holder.querySelector(".noListings")){

        this.holder.removeChild(this.holder.querySelector(".noListings"));
      
      }
    }
    while(this.holder.querySelector(".dateSpacer")){

      this.holder.removeChild(this.holder.querySelector(".dateSpacer"));
    
    }
    while(this.holder.querySelector(".dateHeader")){

      this.holder.removeChild(this.holder.querySelector(".dateHeader"));
    
    }
/*
    while(this.holder.querySelector(".eventsLoadMore")){
      this.holder.removeChild(this.holder.querySelector(".eventsLoadMore"));
    
    }
 */ 
    this.dayNum = 0;
    this.nextDayLinkLoaded = false;
    this.startTimestamp = newTimestamp;
    
    await this.loadNextDay();
    await this.loadNextDay();
    
  },
  events:function(){
    window.addEventListener("resize",()=>{
      this.headerOffset = false;
    });


    var eventListEnd = document.getElementById("eventListEnd");
    if(eventListEnd && eventListEnd.querySelector("button")){
      eventListEnd.querySelector("button").addEventListener("click",(e)=>{
        e.preventDefault();
        this.loadMoreClick();
      });
    }

    var endObserver = new IntersectionObserver((entries)=>{
      if(entries[0].isIntersecting){
        if(!this.loading){
          this.loadNextDay();
        } 
      }
    },{
      rootMargin:`-200px 0px 0px 0px`
    });

    if(eventListEnd){
      endObserver.observe(eventListEnd);
    }
    

  },
  loadMoreClick:function(){
    console.log("LOAD MORE CLICK");
    if(this.dayNum >= this.maxDays){
      this.timestamp = this.timestamp+86400000;
      this.date = new Date();
      this.date.setTime(this.timestamp);
      var dateString = (this.date.getUTCMonth()+1)+"-"+this.date.getUTCDate()+"-"+this.date.getUTCFullYear();

      this.loadNewDate(dateString);
      return;
    }
    if(!this.loading){
      this.loadNextDay();
    }
  },
  nextDayLink:function(){
    if(this.nextDayLinkLoaded) return;
    this.nextDayLinkLoaded = true;
    this.timestamp = this.timestamp+86400000;
    this.date = new Date();
    this.date.setTime(this.timestamp);
    document.getElementById("eventListEnd").style.display = "none";

    var newLink = ELAJAX.homeURL+"date/"+this.date.getFullYear()+"/"+(this.date.getUTCMonth()+1)+"/"+this.date.getUTCDate()+"/";
    var button = document.createElement("button");
    button.innerHTML = "LOAD MORE EVENTS";
    button.classList.add("eventsLoadMore");
    button.addEventListener("click",(e)=>{ 
      e.preventDefault();
      //elLoader.show("Loading Events...");
      this.loadNewDate((this.date.getUTCMonth()+1)+"-"+this.date.getUTCDate()+"-"+this.date.getUTCFullYear());
      //parent.location = newLink;
    });
    var spacer = document.createElement("div");
    spacer.classList.add("dateSpacer");
    this.holder.append(spacer);
    this.holder.append(button);


  },
  loadNextDay:async function(){
    if(this.dayNum >= this.maxDays) return;
    this.timestamp = this.startTimestamp+(86400000*this.dayNum);
    this.date = new Date();
    this.date.setTime(this.timestamp);
    this.dateString = (this.date.getUTCMonth()+1)+"-"+this.date.getUTCDate()+"-"+this.date.getUTCFullYear();
    await this.loadDate();
  },
  dateLoader:function(){
    var loaderDiv = document.createElement("div");
    loaderDiv.classList.add("dateLoader");
    var line = document.createElement("div");
    line.classList.add("line");
    loaderDiv.append(line);
    loaderDiv.append(line.cloneNode());
    loaderDiv.append(line.cloneNode());
    loaderDiv.append(line.cloneNode());
    loaderDiv.append(line.cloneNode());
    loaderDiv.append(line.cloneNode());
    loaderDiv.append(line.cloneNode());
    loaderDiv.append(line.cloneNode());
    


    this.holder.append(loaderDiv);
  },
  loadDate:async function(){
    this.loading = this.dateString;
    var spacer = document.createElement("div");
    spacer.classList.add("dateSpacer");
    this.holder.append(spacer);
    this.dateHeader();
    this.dateLoader();

    this.disableScrollEvent = false;
    var events_onetime = await this.getCache(this.dateString);

    var repeat_day = "repeat_day_"+this.date.getUTCDay();
    var events_repeat_day = await this.getCache(repeat_day);

    var repeat_date = "repeat_date_"+this.date.getUTCDate();
    var events_repeat_date = await this.getCache(repeat_date);

    var weekNum = Math.ceil(this.date.getUTCDate()/7);
    var repeat_day_week = "repeat_day_week_"+this.date.getUTCDay()+":"+weekNum;
    var events_repeat_day_week = await this.getCache(repeat_day_week);


    var data = [...events_onetime,...events_repeat_day,...events_repeat_date,...events_repeat_day_week];

    if(this.listRegionName){
      data = data.filter(d=>{
        if(d.region == this.listRegionName){
          return true;
        }
        return false;
      });
      
    }

    data = data.sort((a,b)=>{
      a.dates = a.dates.sort((aa,bb)=>{
        if(aa.startTime == bb.startTime) return 0;
        return aa.startTime > bb.startTime ? 1 : -1;
      });

      b.dates = b.dates.sort((aa,bb)=>{
        if(aa.startTime == bb.startTime) return 0;
        return aa.startTime > bb.startTime ? 1 : -1;
      });

      var aStart = a.dates.find(aDates=>{
        return aDates.date == this.dateString;
      }) || a.dates[0];
      var bStart = b.dates.find(bDates=>{
        return bDates.date == this.dateString;
      }) || b.dates[0];

      var aVar = aStart.startTime;
      var bVar = bStart.startTime;

      if(a.featured){
        aVar = aVar - 1;
      }
      if(b.featured){
        bVar = bVar - 1;
      }

      if(aVar == bVar) return 0;
      return aVar > bVar ? 1 : -1;
    });

    var dateLoader = document.querySelector(".dateLoader");
    if(dateLoader){
      dateLoader.remove();
    }

    // remove duplicate event
    data = [...new Map(data.map(e=>[e.eventHash,e])).values()];

    this.display(data);
    await new Promise((resolve,reject)=>{
      setTimeout(()=>{
        resolve(true);
      },600);
    });
    this.loading = false;
    this.dayNum++;

    this.updateFilterCount();
    return true;

  }, 
  closeFilter:function(){
    setTimeout(()=>{
      if(filterSelect){
        filterSelect.updateValue(this.filterRegionName || "");
      }
      
      var category_inputs = document.querySelectorAll(".filterCategory");
      category_inputs.forEach(c=>{
        if(this.filterCategoryNames.includes(c.value)){
          c.checked = true;
        }
        else{
          c.checked = false;
        }

      });
    },100);
  },
  updateFilterCount:function(regionName=false){
    var regionOverride = regionName === false ? false : true;
    if(regionName == ""){
      regionName = false;
    }
    var elements = document.querySelectorAll("[data-filterCount]");
    var events = this.holder.querySelectorAll(".event");
    elements.forEach(filterElement=>{
      var count = 0;
      var category = filterElement.getAttribute("data-filterCount");
      events.forEach(e=>{
        if(e.getAttribute("data-category").indexOf(category) >= 0){
          if(regionOverride){
            if(regionName && regionName == e.getAttribute("data-region")){
              count++;
            }
            else if(!regionName){
              count++;
            }
          }
          else if(!regionName && (!this.filterRegionName || this.filterRegionName == e.getAttribute("data-region"))){
            count++;
          }
        }
      });

      if(count > 0){
        filterElement.style.display = "block";
        filterElement.querySelector(".count").innerHTML = "("+count+")";
      }
      else{
        filterElement.style.display = "none";
      }


    });

  },
  getCache:async function(cacheKey){
    var result = await new Promise((resolve,reject)=>{
      var dateObj = new Date();
      var minuteBreaker = Math.floor(dateObj.getUTCMinutes() / 20);
      minuteBreaker = 1;
      var cacheBreaker = dateObj.getUTCMonth() + "-" + dateObj.getUTCDate() + "-" + dateObj.getUTCFullYear() + "-" + dateObj.getUTCHours() + "-" + minuteBreaker;
      //cacheBreaker = dateObj.getTime();
      fetch(this.cacheRoot+cacheKey+".cache?v="+cacheBreaker)
        .then(res=>res.json())
        .then(data=>{
          resolve(data);
        }).catch(e=>{
          resolve([]);
        });

        

    });
    return result;

  },
  clearFilters:function(){
    var category_inputs = document.querySelectorAll(".filterCategory:checked");
    category_inputs.forEach(c=>{
      c.checked = false;
    });

    document.getElementById("filterRegion").selectedIndex = 0;
    if(filterSelect){
      filterSelect.updateValue("");
    }

    this.applyFilters();
    this.updateFilterCount();
  },
  applyFilters:function(){
    var regionName = document.getElementById("filterRegion").value;

    if(regionName == ""){
      this.filterRegionName = false;
    }
    else{
      this.filterRegionName = regionName;
    }


    var categories = document.querySelectorAll(".filterCategory:checked");
    this.filterCategoryNames = [];
    categories.forEach(c=>{
      this.filterCategoryNames.push(c.value);
    });

    var events = this.holder.querySelectorAll(".event");
    events.forEach(e=>{
      if(this.filterCategoryNames.length == 0){
        if(!this.filterRegionName || this.filterRegionName == e.getAttribute("data-region")){
          e.style.display = "block";
        }
        else{
          e.style.display = "none";
        }
      }
      else{
        var hasCategory = this.filterCategoryNames.find(c=>{
          return e.getAttribute("data-category").indexOf(c) >= 0 ? true : false;
        });
        if(hasCategory){
          if(!this.filterRegionName || this.filterRegionName == e.getAttribute("data-region")){
            e.style.display = "block";
          }
          else{
            e.style.display = "none";
          }
        }
        else{
          e.style.display = "none";
        }
      }
    });



    this.filterCounts();
    var eventListBounds = this.holder.getBoundingClientRect();
    window.scrollTo({top:eventListBounds.top + window.scrollY-this.headerOffset+1,behavior:"smooth"});

  },
  filterCounts:function(){
    var filterCount = this.filterRegionName ? 1 : 0;
    filterCount += this.filterCategoryNames.length;

    var filterButtons = document.querySelectorAll(".filterCount");
    filterButtons.forEach(b=>{
      if(filterCount > 0){
        b.style.display = "block";
        b.innerHTML = filterCount;
        return;
      }
      b.style.display = "none";
    });
  },
  filterCategory:function(){


    var categories = document.querySelectorAll(".filterCategory:checked");
    this.filterCategoryNames = [];
    categories.forEach(c=>{
      this.filterCategoryNames.push(c.value);
    });

    var events = this.holder.querySelectorAll(".event");
    events.forEach(e=>{
      if(this.filterCategoryNames.length == 0){
        e.style.display = "block";
      }
      else{
        var hasCategory = this.filterCategoryNames.find(c=>{
          return e.getAttribute("data-category").indexOf(c) >= 0 ? true : false;
        });
        if(hasCategory){
          e.style.display = "block";
        }
        else{
          e.style.display = "none";
        }
      }
    });

  },
  filterRegion:function(regionName){
    if(regionName == ""){
      this.filterRegionName = false;
    }
    else{
      this.filterRegionName = regionName;
    }
    var events = this.holder.querySelectorAll(".event");
    events.forEach(e=>{
      if(this.filterRegionName === false){
        e.style.display = "block";
      }
      else if(e.getAttribute("data-region") == this.filterRegionName){
        e.style.display = "block";
      }
      else{
        e.style.display = "none";
      }
    });

  },
  expand:function(eventHash,event=false){

    eventPopup.showEvent(eventHash,event);
  },
  display:function(data){

    


    if(data.length == 0){
      var emptyHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Calendar Clear</title><rect fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32" x="48" y="80" width="416" height="384" rx="48"/><path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32" stroke-linecap="round" d="M128 48v32M384 48v32M464 160H48"/></svg>';
      emptyHTML += '<span>No Event Listings for '+this.dateString.replace(/\-/g,"/")+'</span>';
      emptyHTML += '</div>';
      var emptyDiv = document.createElement("div");
      emptyDiv.classList.add("noListings");
      emptyDiv.innerHTML = emptyHTML;
      this.holder.append(emptyDiv);
    }

    data.forEach(d=>{
      var itemDiv = document.createElement("a");
      itemDiv.classList.add("event");
      itemDiv.setAttribute("data-region",d.region);
      itemDiv.setAttribute("data-category",d.category);
      itemDiv.setAttribute("href",ELAJAX.homeURL + "event/"+d.eventHash);

      if(this.filterRegionName && d.region !== this.filterRegionName){
        itemDiv.style.display = "none";
      }
      if(this.filterCategoryNames.length){
        var hasCategory = this.filterCategoryNames.find(c=>{
          return d.category.indexOf(c) >= 0 ? true : false;
        });
        if(!hasCategory){
          itemDiv.style.display = "none";
        }
      }

      if(d.image && d.featured){
        var bgImage = document.createElement("img");
        bgImage.classList.add('eventbg');
        bgImage.setAttribute('data-defer-image',d.image);
        bgImage.setAttribute("data-nowebp","true");
        itemDiv.append(bgImage);
      }
      else if(d.featured){  
        var bgImage = document.createElement("img");
        bgImage.classList.add('eventbg');
        bgImage.setAttribute('data-defer-image',ELAJAX.images+'defaultImage.png');
        bgImage.setAttribute("data-nowebp","true");
        itemDiv.append(bgImage);
      }
      

      var eHolderHTML = ""; 
      var eventHolder = document.createElement("div");
      eventHolder.classList.add("eventHolder");
      eventHolder.addEventListener("click",(e)=>{
        e.preventDefault();
        this.expand(d.eventHash,e);
      });

      if(!d.featured){
        eventHolder.classList.add("standardListing");
      }

      //if(d.featured){
        eHolderHTML += '<div class="eventImage">';
        if(d.featured){
          eHolderHTML += this.dateBlock(d);
        }
        if(d.image){
          eHolderHTML += '<img data-nowebp="true" class="main" data-defer-image="'+d.image+'"/>';
          if(!d.featured){
            eHolderHTML += '<img data-nowebp="true" class="bg" data-defer-image="'+d.image+'"/>';
          }
        }
        else{  
          eHolderHTML += '<img data-nowebp="true" class="main" data-defer-image="'+ELAJAX.images+'defaultImage.png"/>';
          eHolderHTML += '<img data-nowebp="true" class="bg" data-defer-image="'+ELAJAX.images+'defaultImage.png"/>';
        }
        eHolderHTML += '</div>';
    //  }

      eHolderHTML += '<div class="text">';

      eHolderHTML += '<h3>'+d.title+'</h3>';

      eHolderHTML += '<span class="eventTime">';
      eHolderHTML += d.dates[0].dateString+' &middot; '+this.displayTimes(d.dates);
      eHolderHTML += '</span>';

      eHolderHTML += '<span class="subText"><b>'+d.region+'</b> &middot; '+d.address+'</span>';
      eHolderHTML += '<span class="eventTags"><span class="tag">';
      eHolderHTML += d.category.replace(/,/g,'</span><span class="tag">');
      eHolderHTML += '</span></span>';
      eHolderHTML += '</div>';
      eHolderHTML += '</div>';
      eHolderHTML += '</div>';
      eventHolder.innerHTML = eHolderHTML;
      itemDiv.append(eventHolder);
      this.holder.append(itemDiv);
      if(d.featured){
        itemDiv.classList.add("featured");
      }



    });

    deferImages.load();


  },
  displayTimes:function(dates){


    var date = dates.filter(d=>{
      var weekNum = Math.ceil(this.date.getUTCDate()/7);
      if(d.repeat_day !== null && d.repeat_day == this.date.getUTCDay()){
        return true;
      }
      else if(d.repeat_date !== null && d.repeat_date == this.date.getUTCDate()){
        return true;
      }
      else if(d.repeat_day_week !== null && d.repeat_day_week == this.date.getUTCDay() + ":" + weekNum){
        return true;
      }
      return d.date == this.dateString;
    });
    var returnVal = "";
    date.forEach((d,index)=>{
      if(index > 0){
        returnVal += " &middot; ";
      }
      returnVal += d.timeString;
    });
    return returnVal;
  },
  dateBlock:function(event){
    var weekdays = ["Sunday","Monday","Tuesday","Weds","Thurs","Friday","Sat"];
    var months = ["Jan","Feb","Mar","Apr","May","June","July","Aug","Sep","Oct","Nov","Dec"];
    var dayName = weekdays[this.date.getUTCDay()];
    var monthName = months[this.date.getUTCMonth()];
 

    if(event.dates[0].repeat_day !== null && event.dates[0].repeat_day == this.date.getUTCDay()){
      return '<div class="eventDate"><div class="eventDateHolder"><span class="day" style="line-height:1.4em;"><i>EVERY</i><br/>'+weekdays[event.dates[0].repeat_day]+'</span></div></div>';
    }
    else{
      dateObj = new Date();
      dateObj.setTime(event.dates[0].timestamp);
      return '<div class="eventDate"><div class="eventDateHolder">'+this.date.getUTCDate()+'<span class="day">'+monthName+'</span></div></div>';
    }




  },
  fromNow:function(dates,holderID=false){
    var nowString = false;
    var endString = false;
    var selectedDate = false;
    dates = JSON.parse(dates);
    var dateObj = new Date(Date.UTC(moment.tz(this.timezone).format("YYYY"),moment.tz(this.timezone).format("M")-1,moment.tz(this.timezone).format("D")));
    var timestamp = dateObj.getTime();
    var currentTime = (moment.tz(this.timezone).format("H") * 60*60);
    currentTime += (moment.tz(this.timezone).format("m")*60);
    currentTime *= 1000;

    timestamp = timestamp - (this.timezoneOffset*60*60*1000);

    var today_repeat_day = parseInt(moment().tz(this.timezone).format("e"));
    var dateString = moment.tz(this.timezone).format("M") + "-" + moment.tz(this.timezone).format("D") + "-" + moment.tz(this.timezone).format("YYYY");

    dates.forEach(d=>{
      if(d.repeat_day !== null){
        if(d.repeat_day == today_repeat_day){
          nowString = moment.utc(timestamp + d.startTime).from();
          endString = moment.utc(timestamp + d.endTime).from();
          selectedDate = d;
        }
      }
      else {
        if(d.date == dateString){

          d.timestamp = d.timestamp - (this.timezoneOffset*60*60*1000);
          nowString = moment.utc(d.timestamp+d.startTime).from();
          endString = moment.utc(d.timestamp + d.endTime).from();
          selectedDate = d;

        }
      }
    });
    if(holderID){
      var holder = document.getElementById(holderID);
      
    }
    else{
      var holder = document.getElementById("fromNow");
    }
    
    if(holder){
    
      if(nowString){

        holder.style.display = "block";
        if(selectedDate.endTime < currentTime){
            holder.innerHTML = "Already Ended for Today";
        }
        else{
          if(nowString.indexOf("ago") > 0){
            holder.innerHTML += "Ending "+endString;
            //holder.innerHTML = "Started "+nowString;
          }
          else{
            holder.innerHTML = "Starting "+nowString;
          }
        }


      }
      else{
        holder.style.display = "none";
      }
    }

  },
  dateHeader:function(){
    var dateHeader = document.createElement("h1");
    dateHeader.classList.add("dateHeader");

    dateHeader.innerHTML = "<span class='dateText'><div class='bigText'><small>"+moment.utc(this.date).format("MMMM")+"</small>"+moment.utc(this.date).format("D")+"<small style='font-weight:normal;'>"+moment.utc(this.date).format("dddd")+"</small></div><div class='smallText'><small>"+moment.utc(this.date).format("MMM")+"</small>"+moment.utc(this.date).format("D")+"<small style='font-weight:normal;'>"+moment.utc(this.date).format("ddd")+"</small></div></span>";
      
    

    
    
    this.holder.append(dateHeader);
/*
    var createButton = (text,icon,className) => {
      var button = document.createElement("div");
      button.classList.add("dateHeaderButton");
      button.classList.add(className);
      button.innerHTML = icon + "<span class='dateHeaderButtonText'>"+text+"</span>";



      return button;
    };

    var calendarButton = createButton("Change Date",'<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Calendar</title><rect fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32" x="48" y="80" width="416" height="384" rx="48"/><circle fill="currentColor" cx="296" cy="232" r="24"/><circle fill="currentColor" cx="376" cy="232" r="24"/><circle fill="currentColor" cx="296" cy="312" r="24"/><circle fill="currentColor" cx="376" cy="312" r="24"/><circle fill="currentColor" cx="136" cy="312" r="24"/><circle fill="currentColor" cx="216" cy="312" r="24"/><circle fill="currentColor" cx="136" cy="392" r="24"/><circle fill="currentColor" cx="216" cy="392" r="24"/><circle fill="currentColor" cx="296" cy="392" r="24"/><path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32" stroke-linecap="round" d="M128 48v32M384 48v32"/><path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32" d="M464 160H48"/></svg>',"calendarButton");
    
    var filterButton = createButton("Filter",'<div class="filterCount"></div><svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Filter</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M32 144h448M112 256h288M208 368h96"/></svg>','filterButton');
    
    dateHeader.append(filterButton);
    dateHeader.append(calendarButton);
    filterButton.onclick = openFilter;
    calendarButton.onclick = openCalendar;

  */
    this.filterCounts();

  },
  getDateCacheKey:function(date){
    let type = "onetime";
    if(date.repeat_day){
      return "repeat_day_"+date.repeat_day;
    }
    else if(date.repeat_date){
      return "repeat_date_"+date.repeat_date;
    }
    else if(date.repeat_day_week){
      return "repeat_day_week_"+date.repeat_day_week;
    }
    else{
      return date.date;
    }

  },
};
